/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import styled from "styled-components";
import Dialog from "@material-ui/core/Dialog";
import React from "react";

const StyledDialog = styled((props) => <Dialog {...props} />)`
  && {
  }
`;

export { StyledDialog };
